const ZIPCodeDirective = angular
    .module("ZIPCodeDirective", [])
    .directive("zipCode", ["$compile", zipCodeDirective])
    .directive("zipCodeValidator", zipCodeValidator);

/**
 * @see http://stackoverflow.com/a/19228302/4454238
 */
function zipCodeDirective($compile) {
    return {
        restrict: "A",
        replace: false,
        terminal: true,
        priority: 1000,
        compile: function compile(element, attrs) {
            let DOM_element = element[0];
            DOM_element.setAttribute("zip-code-validator", "");
            DOM_element.removeAttribute("zip-code");
            DOM_element.removeAttribute("data-zip-code");
            return {
                pre: function preLink(scope, iElement, iAttrs) {},
                post: function postLink(scope, iElement, iAttrs) {
                    $compile(iElement)(scope);
                }
            };
        }
    };
}

/**
 * Extends the AngularJS $validators to validate an input field for 5 or 9-digit
 * ZIP Code formatted as ##### or #####-####.
 *
 * Usage:
 * <input type="text" name="zipCode" ng-model="myModel.zipCode" zip-code-validator />
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
function zipCodeValidator() {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            let DOM_element = elem[0];
            var pattern = /^\d{5}$/;
            var newValue = null;

            ["keyup", "paste", "focus", "blur"].forEach((e) => {
                DOM_element.addEventListener(e, function () {
                    var val = DOM_element.value;
                    ctrl.$setViewValue(val);
                    ctrl.$render();
                });
            });

            ctrl.$validators.zipCodeFormat = function (value) {
                if (newValue !== null && value != newValue) {
                    value = newValue;
                }

                return value === "" ? true : pattern.test(value);
            };
        }
    };
}

export default ZIPCodeDirective;
